import EventEmitter from "eventemitter3";
import type {
  PushNotification,
  PushNotificationResponse,
} from "../models/push-notification.model";

// export type RopV2WebAppConsoleMessage = {
//   // isRopV2AppEvent: boolean;
//   type: "Console";
//   data: {
//     type: "debug" | "log" | "info" | "warn" | "error";
//     log: unknown[];
//   };
// };

export type RopV2WebAppWebappStatusMessage = {
  // isRopV2AppEvent: boolean;
  type: "WEBAPP_STATUS";
  data: "INITIALIZED" | "FINISHED";
};

export type RopV2AppApplicationInfoMessage = {
  isRopV2AppEvent: true;
  type: "APPLICATION_INFO";
  data: {
    applicationName: string | null;
    nativeApplicationVersion: string | null;
    nativeBuildVersion: string | null;
    deviceInfo: {
      isRealDevice: boolean | null;
      deviceName: string | null;
      brand: string | null;
      modelName: string | null;
      totalMemory: number | null;
      deviceType: string | null;
      deviceYearClass: number | null;
      manufacturer: string | null;

      os: string | null;
      osName: string | null;
      osVersion: string | null;
      osBuildId: string | null;

      android?: {
        platformApiLevel: number | null;
        productName: string | null;
        designName: string | null;
      };

      ios?: {
        modelId: string | null;
      };
    };
  };
};

export type RopV2AppPushTokenMessage = {
  isRopV2AppEvent: true;
  type: "PUSH_TOKEN";
  data: string;
};

export type RopV2AppPushDeviceIdMessage = {
  isRopV2AppEvent: true;
  type: "PUSH_DEVICE_ID";
  data: string;
};

export type RopV2AppPushNotificationMessage = {
  isRopV2AppEvent: true;
  type: "PUSH_NOTIFICATION";
  data: PushNotification;
};

export type RopV2AppPushNotificationResponseMessage = {
  isRopV2AppEvent: true;
  type: "PUSH_NOTIFICATION_RESPONSE";
  data: PushNotificationResponse;
};

/** RopV2AppEvent representa os eventos gerados pelo aplicativo */
export type RopV2AppMessage =
  | RopV2AppApplicationInfoMessage
  | RopV2AppPushTokenMessage
  | RopV2AppPushDeviceIdMessage
  | RopV2AppPushNotificationMessage
  | RopV2AppPushNotificationResponseMessage;

/** RopV2WebAppEvent representa os eventos gerados pela página web */
export type RopV2WebAppMessage =
  //| RopV2WebAppConsoleMessage
  RopV2WebAppWebappStatusMessage;

type RopV2AppEvents = {
  ropV2AppInfo: (info: RopV2AppApplicationInfoMessage) => void;
  ropV2AppPushToken: (token: RopV2AppPushTokenMessage) => void;
  ropV2AppPushDeviceId: (deviceId: RopV2AppPushDeviceIdMessage) => void;
  ropV2AppPushNotification: (
    notification: RopV2AppPushNotificationMessage
  ) => void;
  ropV2AppPushNotificationResponse: (
    notificationResponse: RopV2AppPushNotificationResponseMessage
  ) => void;
};

export class RopV2AppEventManager extends EventEmitter<RopV2AppEvents> {
  public get runningInRopV2App() {
    return !!window.ReactNativeWebView;
  }

  public constructor() {
    super();
    window.addEventListener("message", this.handleMessage.bind(this));
  }

  private handleMessage(event: MessageEvent<unknown>) {
    if (!this.runningInRopV2App) {
      // console.debug("Ignorando leitura de evento fora do app ROPv2");
      return;
    }

    console.debug("Lendo evento dentro do app ROPv2");

    const unknownObjMsg: any = event.data;

    // Os eventos do ROPv2 contém a propriedade isRopV2AppEvent como true
    if (!unknownObjMsg?.isRopV2AppEvent) {
      console.debug("Ignorando mensagem que não é um evento do ROPv2.");
      return;
    }

    const objMsg = unknownObjMsg as RopV2AppMessage;

    switch (objMsg.type) {
      case "APPLICATION_INFO":
        this.emit("ropV2AppInfo", objMsg);
        break;
      case "PUSH_TOKEN":
        this.emit("ropV2AppPushToken", objMsg);
        break;
      case "PUSH_DEVICE_ID":
        this.emit("ropV2AppPushDeviceId", objMsg);
        break;
      case "PUSH_NOTIFICATION":
        this.emit("ropV2AppPushNotification", objMsg);
        break;
      case "PUSH_NOTIFICATION_RESPONSE":
        this.emit("ropV2AppPushNotificationResponse", objMsg);
        break;
      default:
        console.warn("Evento não tratado:", objMsg);
        break;
    }
  }

  private sendJsonMessage(message: RopV2WebAppMessage) {
    if (!window.ReactNativeWebView) {
      console.debug("Ignorando envio de evento nativo fora do app ROPv2");
      return;
    }

    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }

  public sendWebAppStatusEvent(evtData: "INITIALIZED" | "FINISHED") {
    type WebAppStatusEvent = {
      type: "WEBAPP_STATUS";
      data: "INITIALIZED" | "FINISHED";
    };

    const evt: WebAppStatusEvent = {
      type: "WEBAPP_STATUS",
      data: evtData,
    };

    this.sendJsonMessage(evt);
  }
}

export const ropV2AppEventManager = new RopV2AppEventManager();
